import { watch } from 'vue'
import type { RouteLocationNormalized, Router } from 'vue-router'
import { locale, t } from '@/composables/useLandingLocale'

/** 由页面自行设置 document.title 的路由 */
const PAGE_OWNED_TITLE = new Set(['SkillDetail', 'About', 'LandingInstallGuide'])

export function applyRouteDocumentTitle(to: RouteLocationNormalized): void {
  if (PAGE_OWNED_TITLE.has(String(to.name ?? ''))) return
  const titleKey = to.meta?.titleKey
  if (typeof titleKey === 'string' && titleKey) {
    document.title = t(titleKey)
  }
}

/** 路由切换与语言切换时同步浏览器标题 */
export function setupRouteDocumentTitle(router: Router): void {
  router.afterEach((to) => {
    applyRouteDocumentTitle(to)
  })
  watch(locale, () => {
    applyRouteDocumentTitle(router.currentRoute.value)
  })
}
